import React, { useEffect, useState } from 'react'
import { useOutletContext, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import moment from 'moment'
import { FaUnlock } from 'react-icons/fa6'
import { MdOutlineCallToAction } from "react-icons/md"

import useFetchData from 'Shared/Hooks/useFetchData'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import { showSuccess } from 'Shared/Components/NotifyToast'
import useLoop from 'Shared/Hooks/useLoop'

const SmartlockData = () => {
  const { role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  const navigate = useNavigate()

  const [lockData, setLockData] = useState([])

  const getLatestData = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/smart_lock/data`,
      returnType: "json"
    })

    body && setLockData(body.map((i) => ({
      "id": i["device_id"],
      "device_name": i["device_name"],
      "battery_level": i["battery_level"],
      "status": (i["status"] != null) ? (i["status"] ? t("smartlock_locked") : t("smartlock_opened")) : null,
      "permit":  i["working_permit"] != null ? (i["working_permit"] ? t("general_yes") : t("general_no")) : null,
      "last_update": (i["last_update"] != null) ? moment(i["last_update"]).format("YYYY-MM-DD HH:mm:ss") : null
    })))
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await Promise.all([
        getLatestData()
      ])

      setPageLoading(false)
    }

    init()
  }, [])

  useLoop(getLatestData, 30000)

  const unlock = async (row) => {
    setPageLoading(true)

    const body = await send({
      method: "POST",
      url: `${apiUrl}/smart_lock/unlock/${row["id"]}`,
      body: JSON.stringify({}),
      returnType: "json"
    })

    if (body != null) {
      showSuccess("Unlock command sent")
    }

    setPageLoading(false)
  }
  
  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={lockData} count={null}
              columns={{
                "device_name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "battery_level": { "label": t("smartlock_batteryLevel"), "sorting": false, "nowrap": true },
                "status": { "label": t("smartlock_status"), "sorting": false, "nowrap": true },
                "permit":  { "label": t("smartlock_permit"), "sorting": false, "nowrap": true },
                "last_update": { "label": t("general_lastUpdate"), "sorting": false, "nowrap": true },
              }}
              renderActions={(row) => { return [
                (["pm", "admin"].includes(role)) && {icon: <FaUnlock size={20}/>, text: t("smartlock_unlock"), onClick: function(row) { unlock(row) }},
                (["client", "so", "pm", "admin"].includes(role)) && {icon: <MdOutlineCallToAction size={20}/>, text: t("smartlock_history"), onClick: function(row) { navigate(`./${row["id"]}`) }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container> 
  </>)
}

export default SmartlockData
